import React from "react";
import "../AllProducts/AllProducts.css";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import BoardsHero from "../../components/pages/AllProducts/Boards/BoardsHero/BoardsHero";
import BoardsTypes from "../../components/pages/AllProducts/Boards/BoardsTypes/BoardsTypes";
import ContinueExploringCategories from "../../components/pages/AllProducts/ContinueExploringCategories/ContinueExploringCategories";

const Boards = () => {
  return (
    <div className="products-page">
      <div className="products-page-content-guide">
        <Navbar theme="dark" />
        <BoardsHero />
        <BoardsTypes />
        <ContinueExploringCategories />
      </div>
      <Footer />
    </div>
  );
};

export default Boards;
